export const storageLocationOptions = [
  {
    label: 'Locked Office',
    key: 'locked_office',
    name: 'storageLocation',
    value: 'locked_office',
  },
  {
    label: 'Vault',
    key: 'vault',
    name: 'storageLocation',
    value: 'vault',
  },
  {
    label: 'Other',
    key: 'other',
    name: 'storageLocation',
    value: 'other',
  },
];

export const storageContainerOptions = [
  {
    label: 'Locked Cabinet',
    key: 'cabinet',
    name: 'storageContainer',
    value: 'cabinet',
  },
  {
    label: 'Locked Closet',
    key: 'closet',
    name: 'storageContainer',
    value: 'closet',
  },
  {
    label: 'Secure Lockbox',
    key: 'lockbox',
    name: 'storageContainer',
    value: 'lockbox',
  },
  {
    label: 'Other',
    key: 'other',
    name: 'storageContainer',
    value: 'other',
  },
];

const editSaveLabels = {
  modalAddTitle: 'testCenter.storage.labelAddPerson',
  modalEditTitle: 'testCenter.storage.editPersonLabel',
  modalAddButton: 'testCenter.storage.labelAddIndividual',
  modalSaveButton: 'testCenter.storage.labelSaveIndividual',
};

export const storageAccessPersonsLabels = {
  sectionTitle: 'testCenter.storage.personsWithKeysMessage',
  modalMessage: 'testCenter.storage.addPersonWithKeyMessage',
  buttonLabel: 'testCenter.storage.labelAddPerson',
  editSaveLabels,
};

export const materialTransferPersonsLabels = {
  sectionTitle: 'testCenter.storage.authorizedPersonsMessage',
  modalMessage: 'testCenter.storage.authorizedPersonsMessage',
  buttonLabel: 'testCenter.storage.labelAddPerson',
  editSaveLabels,
};

export const studentsQuestion = {
  title: 'testCenter.storage.studentsAccessQuestion',
};

export const onTypeRules = {
  firstName: ['name'],
  lastName: ['name'],
};
